module.exports = "/images/FilledPrivacyPolicy.svg?18d366d8cfdb512c0345bdc7e2ab9143";